module.exports = __webpack_public_path__ + "media/images/vector-23@2x-42e7838dc02be3aaa9d5712f329886b2.png";